import Cookie from "./cookie";

/**
 * 国际化
 */
class Locale {
    static _primary = null;

    static get primary() {
        return Locale._primary || (Locale._primary = new Locale());
    }

    constructor() {
        this.key = "lang";
        this.browserLangKey = "browser.lang";
    }

    init(key) {
        this.key = key;
        this.langByUser = Cookie.get(this.key);
        this.langByBrowser = this.getBrowserLang();
        this.langByCookie = Cookie.get(this.browserLangKey);
        if (!this.langByCookie || this.langByBrowser !== this.langByCookie) {
            Cookie.set(this.browserLangKey, this.langByBrowser, {
                expires: 7,
            });
            Cookie.set(this.key, this.langByBrowser);
        }
        if (!this.langByUser) {
            Cookie.set(this.key, this.langByBrowser);
        }
    }

    set(key, lang, options) {
        this.key = key;
        Cookie.set(key, lang, options);
    }

    current() {
        return Cookie.get(this.key);
    }

    getBrowserLang() {
        return navigator.language.split("-")[0];
    }
}

export default Locale.primary;
